import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ml-auto py-3" }
const _hoisted_2 = ["onClick", "textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

import { onMounted, ref } from 'vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import { useOrganizationDocumentStore } from '@/store';
import { useDateTime, can } from '@/composables';
import AddOrganizationDocumentModal from '@/components/UploadModal/AddOrganizationDocumentModal.vue';
import { PERMISSIONS } from '@/enum';

export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationGeneralDocuments',
  setup(__props) {

const organizationDocumentsStore = useOrganizationDocumentStore();
const documentModalOpen = ref(false);

onMounted(() => getDocuments());

const getDocuments = async () => {
  const filter = { tag: 'others' };
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_INDEX])) await organizationDocumentsStore.getGeneralDocuments(filter);
  else doFailUnauthorized('view');
};

const openDocumentUploader = () => (documentModalOpen.value = true);

const doToast = (summary: string, detail: string) => {
  organizationDocumentsStore.doToast(detail, summary);
};

const doFailUnauthorized = (action: string) => {
  organizationDocumentsStore.doToast(`User unauthorized to ${action} documents.`, 'Error');
};

const onSaveAdd = () => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_STORE])) {
    getDocuments();
    doToast('Added', 'New Document has been added');
  } else {
    doFailUnauthorized('upload');
  }
};

const onCancelAdd = () => (documentModalOpen.value = false);

const onDeleteDocument: (id: number) => Promise<void> = async (id) => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_DESTROY])) {
    await organizationDocumentsStore.deleteGeneralDocument(id);
    getDocuments();
    doToast('Removed', 'Document has been removed');
  } else {
    doFailUnauthorized('delete');
  }
};

const onDownloadDocument = async (id: number, name: string) => {
  if (can([PERMISSIONS.ORGANIZATION_DOCUMENTS_DOWNLOAD])) {
    await organizationDocumentsStore.downloadGeneralDocument(id, name);
    doToast('Downloaded', 'Document successfully downloaded');
  } else {
    doFailUnauthorized('download');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_DOCUMENTS_STORE]))
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "primary",
              text: "Upload Document",
              "icon-left": "cloud-upload",
              onClick: openDocumentUploader
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(DataTable), {
        value: _unref(organizationDocumentsStore).generalDocuments.data,
        scrollable: true,
        "loading-icon": "logo-spinner",
        loading: _unref(organizationDocumentsStore).loading,
        "responsive-layout": "scroll",
        "scroll-height": "440px"
      }, {
        empty: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("No documents", -1)
        ]))]),
        default: _withCtx(() => [
          (_unref(organizationDocumentsStore).generalDocuments.data.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(Column), {
                  field: "title",
                  header: "Title",
                  "header-style": "color: #3B4242;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: "download cursor-pointer",
                      onClick: ($event: any) => (onDownloadDocument(data.id, data.name)),
                      textContent: _toDisplayString(data.name)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "description",
                  header: "Description",
                  "header-class": "justify-content-center",
                  "body-class": "justify-content-center text-align-center",
                  "body-style": "font-size: .8725rem;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(data.description)
                    }, null, 8, _hoisted_3)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  field: "created_at",
                  header: "Date Created",
                  "header-class": "justify-content-center",
                  "body-class": "justify-content-center",
                  "body-style": "font-size: .8725rem;"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.created_at))
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Column), {
                  "body-class": "justify-content-center",
                  "body-style": "font-size: .8725rem;",
                  "header-class": "justify-content-center",
                  header: "Actions"
                }, {
                  body: _withCtx(({ data }) => [
                    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_DOCUMENTS_DOWNLOAD]))
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 0,
                          type: "text",
                          size: "large",
                          "icon-left": "cloud_download",
                          class: "text-600 cloud-download",
                          onClick: ($event: any) => (onDownloadDocument(data.id, data.name))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_unref(can)([_unref(PERMISSIONS).ORGANIZATION_DOCUMENTS_DESTROY]))
                      ? (_openBlock(), _createBlock(_component_AppButton, {
                          key: 1,
                          type: "text",
                          size: "large",
                          "icon-left": "delete",
                          class: "text-600",
                          onClick: ($event: any) => (onDeleteDocument(data.id))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["value", "loading"]),
      (documentModalOpen.value && _unref(can)([_unref(PERMISSIONS).ORGANIZATION_DOCUMENTS_STORE]))
        ? (_openBlock(), _createBlock(AddOrganizationDocumentModal, {
            key: 0,
            title: "Upload Document",
            billing: false,
            onCancel: onCancelAdd,
            onSave: onSaveAdd
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})